<template>
  <div
    id="navbar"
    class="bg-primary text-white d-flex flex-column"
    :class="isLarge ? 'groot' : 'klein'"
  >
    <div id="logo" role="button" @click="backToHome">
      <logo src="/images/Peper_badge.png" alt="logo" />
      <logoText class="text-smaller" />
    </div>
    <ul id="nav-links" class="p-0 mb-5 d-flex flex-column align-center justify-content-around">
      <li
        v-for="item in navitems"
        :key="item.naam"
        class="nav-link text-center"
        @click="disableNavigation"
      >
        <router-link :to="item.link" class="text-white">
          {{ item.naam }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import logo from '@/components/Logo.vue';
import logoText from '@/components/LogoText.vue';
import { mapActions } from 'vuex';

export default {
  name: 'navbar',
  components: {
    logo,
    logoText,
  },

  data() {
    return {
      navitems: [
        {
          naam: 'Wie zijn wij?',
          link: '/wiezijnwij',
        },
        {
          naam: 'Leiding',
          link: '/leiding',
        },
        {
          naam: 'Groepen',
          link: '/groepen',
        },
        {
          naam: 'Contact',
          link: '/contact',
        },
        {
          naam: 'Tienkamp',
          link: '/tienkamp',
        },
      ],
      windowWidth: 0,
      navigate: false,
    };
  },
  methods: {
    ...mapActions({
      updateLocation: 'pageLocation/updateLocation',
    }),

    backToHome() {
      if (!this.isLarge) {
        this.navigate = true;
      } else {
        this.updateLocation('home');
        this.$router.push('/');
      }
    },
    disableNavigation() {
      this.navigate = false;
    },

    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  computed: {
    isLarge() {
      return this.windowWidth > 800 || this.navigate;
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
    this.windowWidth = window.innerWidth;
  },
};
</script>
